<template>
    <div>
        <div v-for="(item, index) in lang" :key="index">
            <div class="finish">
                <div class="banner">
                    <img src="@/assets/images/finishpic.png" alt="" />
                </div>
                <div class="textWrap">{{ item[11] }}</div>
                <div class="btnWrap" @click="handleFinish">
                    <img src="@/assets/images/butten_get_en.png" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import queryString from 'query-string'
import { lang } from '@/tool/archeroLang'

var parsed = queryString.parse(location.search || '') || {}

export default {
    data() {
        return {
            isLogged: true,
            lang: [{}],
            language: '',
            lang2: ''
        }
    },
    created() {
        this.getLanguage()
        for (let i in lang) {
            this.lang[0][i] = lang[i][this.language]
        }
    },
    mounted() {},
    methods: {
        handleFinish() {
            this.$emit('handleFinish')
        },
        getLanguage() {
            if (
                parsed.language &&
                (parsed.language === 'en' ||
                    parsed.language === 'zh-TW' ||
                    parsed.language === 'zh-CN' ||
                    parsed.language === 'ja' ||
                    parsed.language === 'ko')
            ) {
                this.language = parsed.language
                // this.abc = this.language
                this.lang2 = this.language.substr(0, 2)
                // this.srcUrl = this.srcList[this.language.substr(0, 2)]
            } else {
                var type = navigator.appName
                if (type == 'Netscape') {
                    var lang = navigator.language //获取浏览器配置语言，支持非IE浏览器
                } else {
                    var lang = navigator.userLanguage //获取浏览器配置语言，支持IE5+ == navigator.systemLanguage
                }
                var lang2 = lang.substr(0, 2) //获取浏览器配置语言前两位
                this.lang2 = lang2
                if (lang2 === 'zh') {
                    let zh = lang.substr(0, 5)
                    this.language = zh
                } else if (lang2 == 'ko') {
                    this.language = 'ko'
                } else if (lang2 == 'ja') {
                    this.language = 'ja'
                } else {
                    this.language = 'en'
                }
                if (this.language === 'zh-cn') {
                    this.language = 'zh-CN'
                }
                if (this.language === 'zh-tw') {
                    this.language = 'zh-TW'
                }
                if (['en', 'ja', 'ko', 'zh-CN', 'zh-TW'].indexOf(this.language) < 0) {
                    this.language = 'en'
                }
                // this.abc = this.language

                // this.srcUrl = this.srcList[this.language.substr(0, 2)]
            }
        }
    }
}
</script>


<style scoped lang="less">
.finish {
    position: relative;

    margin: 0;
    height: 100vh;
    width: 100%;
    background: url('../assets/images/bg.png') 100% 100% no-repeat;
    background-size: 100% 100%;
    padding-top: 10rem;
    text-align: center;
    .banner {
        img {
            width: 59.6875rem;
            // border: 0.375rem solid #fff;
            box-sizing: border-box;
            box-shadow: 2px 2px 4px 8px rgba(255, 255, 255, 0.5);
            // width: 100%;
        }
    }
    .textWrap {
        color: #fff;
        font-size: 2.55rem;
        line-height: 3rem;
        padding: 7.375rem 6.25rem 4.25rem;
    }
    .btnWrap {
        text-align: center;
        img {
            width: 33.75rem;
        }
    }
}

.loggedWrap {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.54);
    .logged {
        position: absolute;
        width: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -70%);
        background: #ffffff;
        width: 56.25rem;
        box-shadow: 0px 8px 36px 0px rgba(0, 0, 0, 0.78);
        text-align: center;
        border-radius: 1.5rem;
        padding: 1.125rem 1.125rem 6.25rem;
    }
    .btn {
        height: 4rem;
        text-align: right;
        img {
            width: 4rem;
        }
    }
    p {
        height: 3rem;
    }
    .text {
        padding: 3.5rem 0 7.5rem;
        font-size: 2.25rem;
        span {
            color: #4380ff;
        }
    }
    .close {
        width: 39.5625rem;
        height: 9.4375rem;
        line-height: 9.4375rem;
        color: #ffffff;
        font-size: 3.125rem;
        display: inline-block;
        border-radius: 4.8125rem;
        background: #568dff;
    }
    .request {
        color: #568dff;
        background: #ffffff;
        border: 0.25rem solid #568dff;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/finish.vue